<div>
  <p class="hmn-color__accent">{{ label || '' | translate }}</p>
  <h5 class="hmn-color__primary hmn-margin__x2-bottom">{{ value || '' | translate }}</h5>
  <app-shared-horiz-bar></app-shared-horiz-bar>
</div>
